export default interface IFloor {
    id: number;
    buildingId: number;
    name: string;
    mapUrl: string;
    hbscanMapUrl: string;
    floorNumber: number;
    managerIds?: number[];
    propertyGroupId: number;
    isOvertimeCalculation: boolean;
}

export const initialFloorState: IFloor = {
    id: 0,
    buildingId: 0,
    name: "",
    mapUrl: "",
    hbscanMapUrl: "",
    floorNumber: 0,
    managerIds: [],
    propertyGroupId: 0,
    isOvertimeCalculation: false,
};
